// src/pages/income/env/disinfection/IncomeEnvDisinfectionDraftList.jsx
// ✅ 환경/소독 "수입목록" 페이지 — 얇은 래퍼.
import React from "react";
import IncomeDraftList from "../../_shared/IncomeDraftList";
import incomeEnvDisinfectionDraftConfig from "./incomeEnvDisinfectionDraftConfig";

export default function IncomeEnvDisinfectionDraftList() {
  return <IncomeDraftList config={incomeEnvDisinfectionDraftConfig} />;
}
